import type { App } from 'vue';
import type { AxiosInterceptorOptions, HttpConfig } from '@/shared/api';
import { getLocaleFromUrl } from '@/app/plugins/i18n';
import { setupHttp } from '@/shared/api';
import {
  onFulfilled,
  onFulfilledV3,
  onRejected,
  onRejectedV3,
  requestSerializerInterceptor,
  responseSerializerInterceptor,
} from './http.interceptors';

export default {
  install(_: App) {
    const apiV2Config: HttpConfig = {
      baseURL: import.meta.env.VUE_APP_API_URL,
      withCredentials: true,
    };

    const interceptors: AxiosInterceptorOptions = {
      response: [[onFulfilled, onRejected], [responseSerializerInterceptor]],
      request: [[requestSerializerInterceptor]],
    };

    setupHttp(apiV2Config, { default: true, version: 'v2', interceptors });

    const { locale } = getLocaleFromUrl();
    const apiV3Config: HttpConfig = {
      baseURL: import.meta.env.VUE_APP_API_V3_URL,
      withCredentials: true,
      headers: {
        Language: locale,
      },
    };

    setupHttp(apiV3Config, { default: false, version: 'v3', interceptors: {
      response: [[onFulfilledV3, onRejectedV3]],
    } });

    // const http = setupHttp(config, interceptors);
    // app.provide<typeof http>('http', http);
    // app.config.globalProperties.$http = http;
  },
};
